import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BookOpen, LogOut, User } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="nav-blur sticky top-0 z-40" data-testid="app-nav">
      <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <BookOpen className="w-5 h-5" strokeWidth={1.5} />
          <span className="font-editorial text-2xl tracking-tight">BookForge360</span>
          <span className="text-xs text-[color:var(--text-muted)] ml-2 hidden sm:inline">
            No.01
          </span>
        </Link>
        <nav className="flex items-center gap-6 text-sm">
          {user ? (
            <>
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  `link-underline ${isActive ? "font-medium" : ""}`
                }
                data-testid="nav-dashboard"
              >
                Library
              </NavLink>
              <NavLink
                to="/library/workspaces"
                className={({ isActive }) =>
                  `link-underline ${isActive ? "font-medium" : ""}`
                }
                data-testid="nav-team"
              >
                Team
              </NavLink>
              <NavLink
                to="/library/clients"
                className={({ isActive }) =>
                  `link-underline ${isActive ? "font-medium" : ""}`
                }
                data-testid="nav-clients"
              >
                Clients
              </NavLink>
              {(user.role || "").toLowerCase() === "admin" && (
                <NavLink
                  to="/admin/free-users"
                  className={({ isActive }) =>
                    `link-underline ${isActive ? "font-medium" : ""}`
                  }
                  data-testid="nav-admin-free-users"
                >
                  Free users
                </NavLink>
              )}
              <div className="hidden sm:flex items-center gap-2 text-[color:var(--text-muted)]">
                <User className="w-4 h-4" strokeWidth={1.5} />
                <span>{user.name || user.email}</span>
              </div>
              <button
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="btn-ghost text-sm inline-flex items-center gap-2"
                data-testid="nav-logout"
              >
                <LogOut className="w-4 h-4" strokeWidth={1.5} /> Log out
              </button>
            </>
          ) : (
            <>
              <NavLink
                to="/features"
                className={({ isActive }) =>
                  `link-underline ${isActive ? "font-medium" : ""}`
                }
                data-testid="nav-features"
              >
                Features
              </NavLink>
              <NavLink
                to="/workspaces"
                className={({ isActive }) =>
                  `link-underline ${isActive ? "font-medium" : ""}`
                }
                data-testid="nav-workspaces-marketing"
              >
                Workspaces
              </NavLink>
              <NavLink
                to="/showcase"
                className={({ isActive }) =>
                  `link-underline ${isActive ? "font-medium" : ""}`
                }
                data-testid="nav-showcase"
              >
                Showcase
              </NavLink>
              <Link to="/pricing" className="link-underline" data-testid="nav-pricing">
                Pricing
              </Link>
              <Link to="/support" className="link-underline" data-testid="nav-support">
                Support
              </Link>
              <Link to="/login" className="link-underline" data-testid="nav-login">Log in</Link>
              <Link to="/register" className="btn-primary text-sm" data-testid="nav-register">
                Start free trial
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
